module.exports = __webpack_public_path__ + "static/fonts/element-icons.6f0a7632.ttf";